import { useEffect, useState } from "react";
import { getProjectUrl } from "../apiConfig";
import { pick } from "../utils/fieldExtractors";

// Fetch a project by id; returns { project, warrantyStart, loading, error }
export function useProject({ projectId, token }) {
  const [project, setProject] = useState(null);
  const [warrantyStart, setWarrantyStart] = useState("");
  const [quoteId, setQuoteId] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    let alive = true;
    if (!projectId || !token) return;
    const endpoint = getProjectUrl(projectId);
    if (!endpoint) return;
    setLoading(true);
    setError("");
    (async () => {
      try {
        const res = await fetch(endpoint, {
          headers: {
            Accept: "application/json",
            Authorization: `${token}`,
          },
        });
        if (!res.ok) throw new Error("Unable to fetch project.");
        const data = await res.json();
        if (!alive) return;
        setProject(data);
        // Extract custom fields
        const cfs = pick(data, "CustomFields") || pick(data, "customFields") || [];
        if (Array.isArray(cfs)) {
          // Warranty Start
          const warrantyMatch = cfs.find(cf => {
            const caption = pick(cf, "Caption") || pick(cf, "caption") || "";
            return caption === "Warranty Start";
          });
          if (warrantyMatch) {
            const val = pick(warrantyMatch, "Value") || pick(warrantyMatch, "value") || "";
            setWarrantyStart(String(val));
          } else {
            setWarrantyStart("");
          }
          // Quote #
          const quoteMatch = cfs.find(cf => {
            const caption = pick(cf, "Caption") || pick(cf, "caption") || "";
            return caption === "Quote #";
          });
          if (quoteMatch) {
            const qVal = pick(quoteMatch, "Value") || pick(quoteMatch, "value") || "";
            setQuoteId(String(qVal));
          } else {
            setQuoteId("");
          }
        } else {
          setWarrantyStart("");
          setQuoteId("");
        }
      } catch (e) {
        if (!alive) return;
        setError(e.message || String(e));
      } finally {
        if (!alive) return;
        setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, [projectId, token]);

  return { project, warrantyStart, quoteId, loading, error };
}
